import React from "react";
import { Reveal, Overline } from "@/components/Reveal";
import { GlowOrb } from "@/components/Decor";
import { PrimaryButton, OutlineButton } from "@/components/Buttons";

export function CTASection({
  title = "Klaar om jouw marketing naar een hoger niveau te tillen?",
  subtitle = "Van één kanaal tot een complete 360°-campagne. Vertel ons waar je staat en wat je wil bereiken — wij bouwen de strategie, creatie en executie eromheen.",
  primaryTo = "/offerte",
  primaryLabel = "Offerte aanvragen",
  secondaryTo = "/diensten",
  secondaryLabel = "Bekijk alle diensten",
}) {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-3xl border border-[#FF4500]/30 bg-[#12151D] p-10 text-center lg:p-20">
          <div className="absolute inset-0 grid-bg opacity-70" />
          <GlowOrb className="left-1/2 -translate-x-1/2 -top-24" color="flame" size={420} />
          <Reveal>
            <Overline>Klaar om te starten</Overline>
            <h2 className="relative mx-auto mt-4 max-w-3xl font-display text-3xl font-bold tracking-tight text-white lg:text-4xl">{title}</h2>
            <p className="relative mx-auto mt-5 max-w-xl text-lg leading-relaxed text-slate-300">{subtitle}</p>
            <div className="relative mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <PrimaryButton to={primaryTo} testid="cta-primary">{primaryLabel}</PrimaryButton>
              <OutlineButton to={secondaryTo} testid="cta-secondary">{secondaryLabel}</OutlineButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
